import { css } from '@/styled-system/css';

export const addMessageWrapperStyles = css.raw({
  display: 'flex',
  gap: 'tight',
  borderWidth: '1px',
  borderTopStyle: 'solid',
  borderColor: 'border.muted',
  padding: 'default',

  lgDown: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    minHeight: '60px',
  },

  lg: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
});

export const desktopLayoutStyles = css.raw({
  display: {
    base: 'none',
    lg: 'flex',
  },
  gap: 'tighter',
  flexDirection: 'column',
});

export const mobileLayoutStyles = css.raw({
  display: {
    base: 'flex',
    lg: 'none',
  },
  flexDirection: 'row',
  width: '100%',
  gap: 'tight',
});
